import { render } from "./SmallModal.vue?vue&type=template&id=2975080a&scoped=true"
import script from "./SmallModal.vue?vue&type=script&lang=js"
export * from "./SmallModal.vue?vue&type=script&lang=js"

import "./SmallModal.vue?vue&type=style&index=0&id=2975080a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2975080a"]])

export default __exports__